export class InsuranceBuilder {
    constructor() {
        this.properties = {};
    }
    forPersonalNumber(personalNumber) {
        this.properties.personalNumber = personalNumber;
        return this;
    }
    withDrivingDistance(drivingDistance) {
        this.properties.drivingDistance = drivingDistance;
        return this;
    }
    withAddOns(addons) {
        this.properties.addons = addons;
        return this;
    }
    build() {
        return this.properties;
    }
}
